import Wrapper from '../shared/Wrapper'
import FeatureCard, { Feature } from './FeatureCard'

import { faBellSlash } from '@fortawesome/pro-solid-svg-icons/faBellSlash'
import { faBrain } from '@fortawesome/pro-solid-svg-icons/faBrain'
import { faChartLineUp } from '@fortawesome/pro-solid-svg-icons/faChartLineUp'
import { faMusic } from '@fortawesome/pro-solid-svg-icons/faMusic'
import { faScreenUsers } from '@fortawesome/pro-solid-svg-icons/faScreenUsers'
import { faUserRobot } from '@fortawesome/pro-solid-svg-icons/faUserRobot'

const features: Feature[] = [
  {
    title: 'Be Coached by the Best',
    description:
      'Choose your perfect virtual coach, dedicated to keeping you on track.',
    icon: faUserRobot,
  },
  {
    title: 'Enjoy Focus Music',
    description:
      '150+ hours of scientifically-designed custom music to help you concentrate.',
    icon: faMusic,
  },
  {
    title: 'Silence the Chatter',
    description: 'While you work, we mute your notifications.',
    icon: faBellSlash,
  },
  {
    title: 'Score Your Productivity',
    description:
      'Improve day-over-day and week-over-week to get your work done faster.',
    icon: faChartLineUp,
  },
  {
    title: 'Learn from the Greats',
    description:
      'Get tips & tricks from the world’s best productivity experts.',
    icon: faBrain,
  },
  {
    title: 'Work with Friends',
    description: 'Enjoy working 1:1 where you can see and hear each other.',
    icon: faScreenUsers,
  },
]

export default function FeatureList(): JSX.Element {
  return (
    <div className="py-20">
      <Wrapper className="text-white">
        <h1 className="font-medium text-center text-4xl mb-10 leading-relaxed">
          All the Productivity Tools You Need <br /> ...in One.
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-5xl mx-auto px-8">
          {features.map((feature, i) => (
            <FeatureCard feature={feature} key={i} />
          ))}
        </div>
      </Wrapper>
    </div>
  )
}
